import { useState } from "react";
import { Box, IconButton, Menu, Avatar, Tooltip, MenuItem, Typography } from '@mui/material';
import theme from "../LayoutComponents/theme";

function ProfileButton({ profile, filename, handlePageClick, page }) {
    const settings = profile?.role !== 'Administrator'
        ? ['Profile', 'Logout']
        : ['Profile', 'Administration', 'Logout'];
    const [anchorElUser, setAnchorElUser] = useState(null);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
            <Tooltip title="Profile, Logout">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                        alt={profile?.name}
                        src={filename}
                        sx={{ bgcolor: theme.colors.yellow }} // <-- makes avatar yellow
                    />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                {settings.map((setting) => (
                    <MenuItem key={setting} onClick={() => {
                        handlePageClick(setting);
                    }}>
                        <Typography sx={{
                            fontSize: '1rem',
                            fontWeight: theme.typography.fontWeightBold,
                            color: theme.colors.purple,
                            borderBottom: page === setting ? '5px solid purple' : 'none',
                        }}>
                            {setting}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>

        </Box>
    )
}

export default ProfileButton;